export function getSearchParams(param: string): string {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param) as string;
}
